module.exports = __webpack_public_path__ + "static/media/undraw_percentages_0rur.78066b56.svg";